import React from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import RadioButtonList from '../radioButtonList/RadioButtonList';
import PrevQuestionLink from '../prevQuestionLink/prevQuestionLink';

const Question3 = props => {
  const isNextDisabled = () => {
    if (props.otherNames?.value === '1' || props.otherNames?.value === '0') {
      return false;
    } else if (props.otherNames?.value === '2') {
      if (
        props.otherNamesArray[0]?.firstName.length !== 0 ||
        props.otherNamesArray[0]?.lastName.length !== 0
      ) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  };

  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <PrevQuestionLink
          setCurrentQuestion={props.setCurrentQuestion}
          prevQuestionIndex={2}
        ></PrevQuestionLink>
        <h3 className={`${styles.pageTitle}`}>Did this person hold accounts in any other name?</h3>
        <p className={styles.questionText}>
          For example, changing your surname after marriage, or an abbreviated first name.
        </p>
        <fieldset className={`nsw-form-fieldset ${styles.nswFormFieldset}`}>
          <RadioButtonList
            list={[
              {
                value: '2',
                label: 'Yes',
                checked: props.otherNames?.value === '2',
              },
              {
                value: '1',
                label: 'No',
                checked: props.otherNames?.value === '1',
              },
              {
                value: '0',
                label: 'Unsure',
                checked: props.otherNames?.value === '0',
              },
            ]}
            id={'otherName'}
            name={'otherName'}
            displayLayout={'horizontal'}
            className={`nsw-form-radio__input ${styles.nswFormRadio__input}`}
            handleChange={(item, name) => {
              props.setOtherNames(item);
            }}
          />
        </fieldset>

        {props.otherNames?.value === '2' ? (
          <div className={`mt-5`}>
            <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
              <label htmlFor={`deceasedGivenName`} className={`${styles.nswFormLabel}`}>
                Other name
              </label>
              <input
                id={'deceasedGivenName'}
                name={'deceasedGivenName'}
                className={`nsw-form-input ${styles.nswFormInput}`}
                value={
                  props.otherNamesArray[0]?.firstName?.length > 0
                    ? props.otherNamesArray[0]?.firstName
                    : undefined
                }
                onInput={event => {
                  props.setOtherNamesArray([
                    { ...props.otherNamesArray[0], firstName: event.target.value },
                  ]);
                }}
              />
            </div>
            <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
              <label htmlFor={`deceasedLastName`} className={`${styles.nswFormLabel}`}>
                Other last name
              </label>
              <input
                id={'deceasedLastName'}
                name={'deceasedLastName'}
                className={`nsw-form-input ${styles.nswFormInput}`}
                value={
                  props.otherNamesArray[0]?.lastName?.length > 0
                    ? props.otherNamesArray[0]?.lastName
                    : undefined
                }
                onChange={event => {
                  props.setOtherNamesArray([
                    { ...props.otherNamesArray[0], lastName: event.target.value },
                  ]);
                }}
              />
            </div>
          </div>
        ) : null}

        <div className={styles.btnWrap}>
          <Button
            disabled={isNextDisabled()}
            onClick={() => {
              props.setCurrentQuestion(4);
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question3;
